module.exports = __webpack_public_path__ + "static/media/private-insurance.fc98dd05.png";